var React = require('react');

function Depot (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Mobile Depot"),React.createElement("path",{"id":"path3624","className":"cls-1","d":"M14,56.86l7.14-7.15H35.43L49.71,35.43H78.29L92.57,49.71h14.29L114,56.86V85.43l-7.14,7.14H92.57l-7.14-7.14H78.29l-7.15,7.14H56.86l-7.15-7.14H42.57l-7.14,7.14H21.14L14,85.43Z","key":2})]);
}

Depot.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Depot;

Depot.default = Depot;
